import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import './MarkdownRenderer.css';

const stripUndefinedArtifacts = (s) =>
  String(s ?? '')
    .replace(/\bundefined\b/gi, '')
    .replace(/\Bundefined\b/gi, '');

const MarkdownRenderer = ({ content, isBot = true, showCursor = false }) => {
  if (content == null) return null;
  if (typeof content !== 'string') return null;

  const sanitized = stripUndefinedArtifacts(content);
  if (!sanitized.trim()) return null;

  return (
    <div className="markdown-content">
      <ReactMarkdown
        remarkPlugins={[remarkBreaks]}
        components={{
          // Remove hash symbols from headings
          h1: ({ children }) => <div className="md-heading md-h1">{children}</div>,
          h2: ({ children }) => <div className="md-heading md-h2">{children}</div>,
          h3: ({ children }) => <div className="md-heading md-h3">{children}</div>,
          h4: ({ children }) => <div className="md-heading md-h4">{children}</div>,
          h5: ({ children }) => <div className="md-heading md-h5">{children}</div>,
          h6: ({ children }) => <div className="md-heading md-h6">{children}</div>,
          
          // Remove asterisks from bold/italic
          strong: ({ children }) => <span className="md-bold">{children}</span>,
          em: ({ children }) => <span className="md-italic">{children}</span>,
          
          // Style paragraphs based on message type
          p: ({ children }) => (
            <div className={isBot ? "md-paragraph-bot" : "md-paragraph"}>
              {children}
            </div>
          ),
          
          // Style lists
          ul: ({ children }) => <ul className="md-list md-ul">{children}</ul>,
          ol: ({ children }) => <ol className="md-list md-ol">{children}</ol>,
          li: ({ children }) => <li className="md-list-item">{children}</li>,
          
          // Style code blocks
          code: ({ inline, children }) => 
            inline ? (
              <code className="md-code-inline">{children}</code>
            ) : (
              <pre className="md-code-block"><code>{children}</code></pre>
            ),
          
          // Style blockquotes
          blockquote: ({ children }) => <blockquote className="md-blockquote">{children}</blockquote>,
        }}
      >
        {sanitized}
      </ReactMarkdown>
      {showCursor && <span className="typing-cursor-md"></span>}
    </div>
  );
};

export default MarkdownRenderer;
